/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
/**
 *
 * App.react.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import GlobalNavBar from "containers/GlobalNavBar";
import jwtDecode from "jwt-decode";
import { array, bool, func, object, number, node, string } from "prop-types";
import queryString from "query-string";
import React from "react";
import Notifications, { success } from "react-notification-system-redux";
import { connect } from "react-redux";
import Loader from "react-loader-advanced";
import { ThreeBounce } from "better-react-spinkit";
import Cookies from "js-cookie";
import { parseISO } from "date-fns";
import * as moment from "moment-timezone";
import { notificationsStyles } from "utils/helperStyles";
import { czKey, teamsUrl } from "utils/env";
import {
  getConfigCatObject,
  isTokenExpired,
  isValidCritToken,
  convertDateTimezone,
} from "utils/helperFunctions";
import { viMerchandizingUtmParams } from "utils/helperConstants";
import { getScheduleDemoUrl } from "components/VideoInterviewMerchandizingModal/helperFunctions";
import {
  getBannedRoutes,
  RolesAccessLibrary,
} from "utils/rolesAccessFunctions";
import {
  segmentIdentifyUser,
  segmentIdentifyGroup,
  trackFTUserAssignedCTA,
} from "utils/trackingFunctions";
import { updateSentryContext } from "utils/sentry";
import SessionExpirationModal from "components/SessionExpirationModal";
import ContactButton from "./ContactButton/ContactButton";
import LoginPage from "./LoginComponents/LoginPage";
import InvoicePayment from "../InvoicePayment";
import RenewBar from "./RenewBar";
import PartnersLoginPage from "./PartnerLoginComponents/PartnersLoginPage";
import NewCriteriaBatteryNotification from "./NewCriteriaBatteryNotification";
import NoAccessPage from "../NoAccessPage";
import DynamicScoreReports from "../DynamicScoreReports";
import HelpAssistantModal from "../../components/HelpAssistantModal";
import {
  getCompanyInfo,
  getInvoice,
  getRoles,
  saveLastLocation,
  getIdentityProvider,
  getDynamicScoreReportsData,
  getUsers,
  refreshUserData,
  setupFeatureFlag,
  setOrderInProcess,
  updateVhs,
  login,
  getTestBatteries,
  resetSupportBotResponse,
  sendResponseFeedback,
  sendSupportBotQuestion,
} from "./actions";
import {
  doDynamicScoreReportsAuth,
  getDynamicScoreReportsToken,
  getVersionName,
  getFreeTrialSubscriptionBannerUTMParams,
} from "./helpers";

let checkUpdatesInterval = null;
let intervalIteration = 0;
let intervalId;

// eslint-disable-next-line react/prefer-stateless-function
export class App extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showUpdatingLoader: false,
      hideOverflow: false,
      expireTime: null,
      showCriteriaBatteryNotification: false,
      viewToDisplay: "none", // shows nothing if roles endpoint hasn't returned yet. after returning, can be "noAccess" (if no permission) or "pageComponent" (show regular page),
      showHelpAssistantModal: false,
    };
  }

  componentDidMount() {
    checkUpdatesInterval = setInterval(() => {
      intervalIteration += 1;
      // if 'showUpdatingLoader' is false, it might just mean that 'installingUpdate' just hasn't yet had the time to update
      // In this case we need to check 'installingUpdate' periodically and showUpdatingLoader to true if an update is installing
      if (
        sessionStorage.getItem("installingUpdate") &&
        !this.state.showUpdatingLoader
      ) {
        this.setState({ showUpdatingLoader: true });
      }
      /*
       * if 'showUpdatingLoader' is true, we need to check periodically if 'installingUpdate'
       * has been set to false.
       * this would mean that there is an update available, but installing the update has failed
       * (probably due to browser settings of the user).
       * in this case reloading the page would just set the user in an infinite loop of HS
       * trying to update, and the update failing.
       * therefore, we need to just set showUpdatingLoader to false and allow the user to use
       * HS without updating
       */

      if (
        sessionStorage.getItem("installingUpdate") === false &&
        this.state.showUpdatingLoader
      ) {
        this.setState({ showUpdatingLoader: false });
      } else if (intervalIteration >= 60) {
        clearInterval(checkUpdatesInterval);
      }
    }, 150);
    
    // Initial update of Sentry context with user data if available
    if (this.props.userData) {
      updateSentryContext(this.props.userData);
    }

    const { userData } = this.props;

    const tkn =
      this.props.location.query.token || localStorage.getItem("token");
    if (tkn) {
      localStorage.setItem("token", tkn);
    } else if (isValidCritToken(Cookies.get("critToken"))) {
      localStorage.setItem("token", Cookies.get("critToken"));
    }

    const dynamicScoreReportsTkn = getDynamicScoreReportsToken();
    const viewingDynamicScoreReports =
      location.pathname.split("/")[1] === "scoreReports" &&
      dynamicScoreReportsTkn;

    if (viewingDynamicScoreReports) {
      doDynamicScoreReportsAuth(dynamicScoreReportsTkn);
    }

    // determine if we should route the user to the partner center logon
    const isPartnerCenterLogon = this.props.location.pathname === "/partners";
    // if the user has a token in the url and is logging in to the Partner Center from the intranet
    // set partners token in local storage here
    if (tkn && isPartnerCenterLogon) {
      localStorage.setItem("partnersToken", tkn);
    } else if (tkn && !isPartnerCenterLogon && !dynamicScoreReportsTkn) {
      if (this.state.expireTime === null) {
        const expireTime = jwtDecode(tkn).exp * 1000;
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ expireTime });
      }
      if (this.props.location.pathname !== "partners") {
        this.props.onGetRoles();
      }
      this.props.onGetCompanyInfo();
      this.props.onGetTestBatteries();
      if (this.props.location.query.token) {
        if (userData && userData.internal) {
          // get hireselect version to be used for segment tracking
          const hsVersion = getVersionName(userData.hsVersion);

          // Get the feature flag for dashboard experiment allocation
          const ftDashboardExperimentAllocation =
            this.props.featureFlags &&
            this.props.featureFlags.get("ftDashboardExperimentAllocation");

          /* Segment SDK Event Tracking */
          // The Group tracking should come after User tracking.
          // This will make it so Segment attaches the User to the Account Group.
          segmentIdentifyUser(
            userData,
            this.props.location.query.token,
            ftDashboardExperimentAllocation
          );
          segmentIdentifyGroup(userData, hsVersion);
        }
      }
    }

    // refresh userData in redux if null
    if (
      localStorage.getItem("token") &&
      !userData &&
      !isPartnerCenterLogon &&
      !viewingDynamicScoreReports
    ) {
      this.props.onRefreshUserData();
    }

    const ChurnZero = ChurnZero || [];
    ChurnZero.push(["setAppKey", czKey]);
    if (checkUpdatesInterval !== null) {
      clearInterval(checkUpdatesInterval);
    }

    if (sessionStorage.getItem("installingUpdate")) {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ showUpdatingLoader: true });
    }

    if (localStorage.getItem("pTS")) {
      localStorage.removeItem("pTS");
    }

    // Clears out token if user is logging in to integrate with linkedIn. This prevents the user from already being logged in when being prompted to login during linkedIn Integration Onboarding
    if (
      this.props.location.pathname === "/liOnboarding" &&
      localStorage.getItem("token")
    ) {
      localStorage.clear();
    }

    if (userData && !viewingDynamicScoreReports) {
      this.handleInitWithUserData();
    }
  }
  
  componentDidUpdate(prevProps) {
    const { userData } = this.props;
    
    // Check if userData has changed - handles both null->value and value->value transitions
    if (prevProps.userData !== userData) {
      // Handle initialization when userData becomes available
      this.handleInitWithUserData();
      
      // Update Sentry context with Redux userData when it becomes available/changes
      if (userData) {
        console.debug('Sentry: userData changed, updating Sentry context');
        updateSentryContext(userData);
      }
    }
    
    // Handle location changes
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.props.onSaveLastLocation(this.props.location.pathname);
    }
    
    // Handle payment confirmation
    if (
      prevProps.paidThisSession &&
      this.props.paidThisSession !== prevProps.paidThisSession
    ) {
      const notificationOpts = {
        message: "Thank you for your order",
        position: "tr",
        autoDismiss: 6,
      };
      this.props.dispatch(success(notificationOpts));
    }

    // Update Appcues with user data
    if (userData) {

      window.Appcues.identify(userData.userAccountId, {
        companyAccountId: userData.companyAccountId,
        companyName: userData.companyName,
        country: userData.addressCountry,
        criteriaRole: userData.roleName,
        dateAccountCreated: userData.dateAccountCreated,
        dateTrialStarted: userData.dateTrialStarted,
        daysRemaining: userData.daysRemaining,
        expired: userData === 1,
        demoLink: getScheduleDemoUrl(
          userData.status === "free_trial",
          userData.rep,
          viMerchandizingUtmParams.tssFreeTrialBanner,
          userData.numberOfEmployees
        ),
        domain: window.location.hostname,
        locale: userData.locale,
        ownerEmail: userData.rep.csm.emailAddress,
        ownerFirstName: userData.rep.csm.firstName,
        ownerLastName: userData.rep.csm.lastName,
        ownerPhone: userData.rep.csm.telephoneNumber,
        planType: userData.type,
        resultsV2: userData.resultsV2,
        freeTrialDaysRemaining_addedByDevelop: userData.freeTrialDaysRemaining,
        subscriptionDaysRemaining_addedByDevelop:
          userData.subscriptionDaysRemaining,
        isFreeTrial_addedByDevelop: userData.isFreeTrial,
        logonCount_addedByDevelop: userData.logonCount,
        freeTrialLogins_addedByDevelop: userData.freeTrialLogins,
        tssLogins_addedByDevelop: userData.tssLogins,
        jobCount_addedByDevelop: userData.jobCount,
        daysSinceLastLogin_addedByDevelop: userData.daysSinceLastLogin,
        viEnabled: userData.videoInterviewsEnabled,
        godmode:
          userData.internal || userData.internalMode === "god" ? "1" : "0", // TODO: remove if we are removing godmode from Criteria Platform
        numberOfCandidatesMovedToDevelop:
          userData.numberOfCandidatesMovedToDevelop,
        hasDevelopEnabled: !!userData.developByCriteriaAccess,
        se_link: getScheduleDemoUrl(
          userData.status === "free_trial",
          userData.rep,
          {},
          userData.numberOfEmployees
        ).split("?")[0],
      });

      if (
        !localStorage.getItem("pTS") &&
        this.props.location.pathname !== "/partners" &&
        this.props.location.pathname !== "/scoreReports" &&
        localStorage.getItem("token") &&
        window.location.href.indexOf("subscribe") < 0 &&
        userData.daysRemaining < 0 &&
        window.location.href.indexOf("payment") < 0 &&
        userData.internal < 1
      ) {
        window.location.href = "/subscribe";
      } else if (
        /*
         * if the location pathname changes, or if roles endpoint returns (when
         * component first mounts), check location against list of banned routes. If banned,
         * show NoAccess view instead
         */

        (this.props.location.pathname !== prevProps.location.pathname ||
          this.props.roles.size !== prevProps.roles.size ||
          this.props.userData !== prevProps.userData ||
          this.props.companyInfo !== prevProps.companyInfo) &&
        this.props.roles.size > 0
      ) {
        const bannedRoutes = getBannedRoutes(
          this.props.roles,
          this.props.userData,
          this.props.companyInfo,
          this.props.paidThisSession
        );
        if (
          bannedRoutes.includes(
            this.props.location.pathname.split("/")[1].toLowerCase()
          )
        ) {
          this.setState({ viewToDisplay: "noAccess" });
        } else {
          this.setState({ viewToDisplay: "pageComponent" });
        }
      } else if (
        localStorage.getItem("token") &&
        this.props.location.pathname !== "/partners" &&
        this.props.location.pathname !== "/scoreReports" &&
        userData.suspended &&
        window.location.href.indexOf("subscribe") < 0 &&
        userData.internal < 1 &&
        window.location.href.indexOf("payment") < 0
      ) {
        window.location.href = "/subscribe";
      } else if (
        this.props.identityProviderMode === null &&
        localStorage.getItem("token")
      ) {
        this.props.onGetIdentityProvider(userData.emailAddress);
      }

      if (
        this.props.roles.size !== prevProps.roles.size ||
        this.props.hasCreatedTestBatteries !== prevProps.hasCreatedTestBatteries
      ) {
        const RolesAccessFuncLibrary =
          this.props.roles.size > 0 && userData
            ? RolesAccessLibrary(this.props.roles, userData.roleId)
            : null;
        const jobPermission = RolesAccessFuncLibrary
          ? RolesAccessFuncLibrary.jobsPermission()
          : null;

        const dateLastLoggedOn = convertDateTimezone(
          userData.dateLastLoggedOn,
          false
        );

        const recommendedTestBatteryLiveDate = parseISO(
          moment(
            moment.tz("2021-10-27 10:00:00", "America/Los_Angeles")
          ).format("YYYY-MM-DD HH:mm:ss")
        );

        // representing the current time in the Pacific Time Zone
        const dateNow = parseISO(
          moment().tz("America/Los_Angeles").format("YYYY-MM-DD HH:mm:ss")
        );

        const showCriteriaBatteryNotification =
          dateNow > recommendedTestBatteryLiveDate &&
          dateLastLoggedOn < recommendedTestBatteryLiveDate &&
          this.props.hasCreatedTestBatteries;

        if (
          jobPermission &&
          showCriteriaBatteryNotification &&
          !localStorage.getItem("dismissCriteriaBatteryNotification")
        ) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({ showCriteriaBatteryNotification });
        }
      }
    }
  }

  componentWillUnmount() {
    clearInterval(intervalId);
  }

  handleConfigCat = async (userData, tkn) => {
    try {
      const configCatObj = await getConfigCatObject(userData);
      // we need to check here for a whether the account has the feature flag turned on,
      // and whether they have teams and/or hireselect access.  if they just have Teams
      // access, then we need to redirect them to the Teams subdomain with the cookie
      // set to the value of the token.  If not, just proceed with normal Criteria
      // login.
      this.props.onSetupFeatureFlags(configCatObj);
      const hasHireSelectAccess = userData.hireselectAccess;
      const hasTeamingAccess = userData.tmgAccess;
      if (hasTeamingAccess && !hasHireSelectAccess) {
        Cookies.set("critToken", tkn, {
          path: "/",
          domain: ".criteriacorp.com",
        });
        localStorage.removeItem("token");
        window.location.href = teamsUrl;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  handleInitWithUserData = async () => {
    const tkn =
      this.props.location.query.token || localStorage.getItem("token");
    const { userData } = this.props;
    if (!tkn && isValidCritToken(Cookies.get("critToken"))) {
      localStorage.setItem("token", Cookies.get("critToken"));

      // when coming to Criteria platform from Talent Insights, we have to
      // explicitly set the version number back into the global App state.
      this.props.onUpdateVhs(userData.hsVersion);
      const configCatPromise = getConfigCatObject(userData);
      configCatPromise.then((configCatObject) =>
        this.props.onSetupFeatureFlags(configCatObject)
      );

      /* Set up ConfigCat for feature flags */
    } else if (tkn) {
      if (userData.sfAccountId && userData.sfContactId) {
        window.ChurnZero.push([
          "setContact",
          `${userData.sfAccountId}`,
          `${userData.sfContactId}`,
        ]);
      }

      await this.handleConfigCat(userData, tkn);
    }

    // determine if we should route the user to the partner center logon
    const isPartnerCenterLogon = this.props.location.pathname === "/partners";
    if (tkn && !isPartnerCenterLogon) {
      if (this.props.location.pathname !== "partners") {
        this.props.onGetRoles();
      }
      this.props.onGetCompanyInfo();
      this.props.onGetTestBatteries();
      this.props.onGetIdentityProvider(userData.emailAddress);

      if (this.props.location.query.token) {
        if (userData && userData.internal) {
          // get hireselect version to be used for segment tracking
          const hsVersion = getVersionName(userData.hsVersion);

          // Get the feature flag for dashboard experiment allocation
          const ftDashboardExperimentAllocation =
            this.props.featureFlags &&
            this.props.featureFlags.get("ftDashboardExperimentAllocation");

          /* Segment SDK Event Tracking */
          // The Group tracking should come after User tracking.
          // This will make it so Segment attaches the User to the Account Group.
          segmentIdentifyUser(
            userData,
            this.props.location.query.token,
            ftDashboardExperimentAllocation
          ).then(() => {
            segmentIdentifyGroup(userData, hsVersion).then(() => {
              if (this.props.userData && this.props.userData.isFreeTrial) {
                const ftWelcomeBannerCtaButtonText =
                  this.props.featureFlags.get("ftWelcomeBannerCtaButtonText");
                trackFTUserAssignedCTA(ftWelcomeBannerCtaButtonText);
              }
            });
          });
        }
      }
    }
  };

  // Method for checking if JWT is expired.  If so, it returns false. Otherwise, true
  checkTokenExpiration = (expireTime) =>
    expireTime >= Math.floor(Date.now() / 1000);

  // Method for determining whether or not to show subscribe/renew banner
  doShowSubscribeBanner = (userData, companyInfo) => {
    const { status, daysRemaining, paid, paidFirstPayment } = userData;

    if (status === "free_trial") {
      return true;
    }

    if (status === "subscriber") {
      if (
        companyInfo.get("autoRenewalEligibility") &&
        companyInfo.get("autoRenewalEnabled")
      ) {
        return false;
      }

      if (daysRemaining <= 60) {
        return true;
      }
      if (daysRemaining > 60 && paid === 0 && paidFirstPayment === 0) {
        return true;
      }
    }
    return false;
  };

  toggleHideOverflow = (hideOverflow) => {
    if (hideOverflow === true || hideOverflow === false) {
      this.setState({ hideOverflow });
    } else {
      this.setState((prevState) => ({
        hideOverflow: !prevState.hideOverflow,
      }));
    }
  };

  dismissNewCriteriaBatteryNotification = () => {
    this.setState({
      showCriteriaBatteryNotification: false,
    });

    localStorage.setItem("dismissCriteriaBatteryNotification", true);
  };

  toggleHelpAssistantModal = () => {
    this.setState((prevState) => ({
      showHelpAssistantModal: !prevState.showHelpAssistantModal,
    }));
  };

  handleCloseHelpAssistantModal = () => {
    this.props.onResetSupportBotResponse();
    this.setState({ showHelpAssistantModal: false });
  };

  handleSendResponseFeedback = (responseQuality) => {
    this.props.onSendResponseFeedback({
      responseId: Number(this.props.trackResponseId),
      quality: Number(responseQuality),
    });
  };

  handleSendSupportBotQuestion = (questionText) => {
    const { companyAccountId, userAccountId } = this.props.userData;
    this.props.onSendSupportBotQuestion({
      questionText,
      companyAccountId,
      platformUserId: userAccountId,
    });
  };

  render() {
    const {
      userData,
      onLogin,
      showSessionExpirationModal,
      loginLoading,
      forceLogout,
      companyInfo,
    } = this.props;

    /*
     * Determine if user is logged in by first checking if the url query string
     * contained a JWT.
     * If not, check to determine if JWT is present in local storage already (meaning
     * they are already logged in).
     * If neither of those are true, display the log in screen.  Otherwise proceed to
     * child route.
     */
    const loginToken =
      queryString.parse(this.props.location.search).token ||
      localStorage.getItem("token") ||
      isValidCritToken(Cookies.get("critToken"));

    const isLoggedIn = loginToken && loginToken.length > 0;
    if (loginToken) {
      localStorage.setItem("token", loginToken);
    }

    const viewingDynamicScoreReports =
      location.pathname.split("/")[1] === "scoreReports";

    const paidThisSession = localStorage.getItem("pTS");

    const partnerLoginToken = localStorage.getItem("partnersToken");

    const isInsightUser = userData && userData.partnerAccountId === 47;

    const partnerIsLoggedIn =
      partnerLoginToken &&
      location.pathname.split("/")[1] === "partners" &&
      this.checkTokenExpiration(jwtDecode(partnerLoginToken).exp);

    let doShowBanner = false;
    if (
      isLoggedIn &&
      userData &&
      !viewingDynamicScoreReports &&
      companyInfo &&
      companyInfo.size > 0
    ) {
      // Determine whether or not to show the subscription banner
      doShowBanner = paidThisSession
        ? false
        : this.doShowSubscribeBanner(userData, companyInfo);
    }

    /*
     * Retrieve the tk1 and tk2 from the query string, if present, to be passed
     * to Login Page component.
     * Required if the user is trying to reset their password.
     */

    const tk1 = queryString.parse(this.props.location.search).tk1
      ? queryString.parse(this.props.location.search).tk1
      : null;

    const tk2 = queryString.parse(this.props.location.search).tk2
      ? queryString.parse(this.props.location.search).tk2
      : null;

    /*
     * Display appropriate component depending on if user is logged in or it is an
     * internet log in, or neither, if the route is to /pay, show order form, if the
     * route is to /sso, redirect to the ssoLogin component.
     */
    let ComponentToDisplay = null;
    if (
      location.pathname.split("/")[1] === "pay" ||
      location.pathname.split("/")[1] === "pay-invoice" ||
      location.pathname.split("/")[1] === "invoice_payment"
    ) {
      ComponentToDisplay = (
        <div>
          <InvoicePayment version={location.pathname.split("/")[1]} />
        </div>
      );
    } else if (
      location.pathname.split("/")[1] !== "partners" &&
      !viewingDynamicScoreReports &&
      !forceLogout &&
      (showSessionExpirationModal || !isTokenExpired())
    ) {
      ComponentToDisplay = (
        <div>
          {doShowBanner && userData && (
            <RenewBar
              daysRemaining={userData.daysRemaining}
              demoLink={getScheduleDemoUrl(
                userData.status === "free_trial",
                userData.rep,
                getFreeTrialSubscriptionBannerUTMParams(
                  userData.companyAccountId
                ),
                userData.numberOfEmployees
              )}
              dispatch={this.props.dispatch}
              hasPricing={userData.hasPricing}
              isBuyNowEligible={Boolean(userData.isBuyNowEligible)}
              status={userData.status}
              expired={userData.expired}
            />
          )}
          {location.pathname.split("/")[1] !== "videoInterviewDiscovery" ? (
            <GlobalNavBar
              isLoggedIn={isLoggedIn}
              location={this.props.location}
              toggleHideOverflow={this.toggleHideOverflow}
              featureFlags={this.props.featureFlags}
            />
          ) : null}
          {this.state.viewToDisplay === "pageComponent" ? (
            React.Children.toArray(this.props.children)
          ) : this.state.viewToDisplay === "noAccess" ? (
            <NoAccessPage />
          ) : null}
        </div>
      );
    } else if (partnerIsLoggedIn) {
      ComponentToDisplay = (
        <div>{React.Children.toArray(this.props.children)}</div>
      );
    } else if (viewingDynamicScoreReports) {
      ComponentToDisplay = <DynamicScoreReports />;
    } else {
      ComponentToDisplay =
        location.pathname.split("/")[1] === "partners" ? (
          <PartnersLoginPage tk1={tk1} tk2={tk2} />
        ) : (
          <LoginPage tk1={tk1} tk2={tk2} />
        );
    }

    return (
      <div className="d-flex flex-column">
        <Loader
          show={this.state.showUpdatingLoader}
          message={
            <div>
              <span style={{ color: "black", fontSize: "25px" }}>
                Please wait while we update Criteria{" "}
              </span>
              <ThreeBounce color="#1F469A" size={10} />
            </div>
          }
          contentBlur={100}
          backgroundStyle={{ backgroundColor: "rgba( 0 0 0 0)" }}
          foregroundStyle={{
            display: "block",
            marginTop: "200px",
            align: "center",
          }}
          messageStyle={{ display: "block" }}
        >
          {userData ? (
            <SessionExpirationModal
              onLogin={onLogin}
              userData={userData}
              showModal={isTokenExpired() && showSessionExpirationModal}
              loginLoading={loginLoading}
            />
          ) : null}
          {ComponentToDisplay}
          {isLoggedIn &&
          loginToken &&
          this.checkTokenExpiration(jwtDecode(loginToken).exp) &&
          location.pathname.split("/")[1] !== "partners" &&
          !viewingDynamicScoreReports
            ? userData && (
                // eslint-disable-next-line react/jsx-indent
                <ContactButton
                  rep={userData.rep}
                  subscriber={userData.status === "subscriber"}
                  userData={userData}
                  toggleHelpAssistantModal={this.toggleHelpAssistantModal}
                  featureFlags={this.props.featureFlags}
                />
              )
            : null}
          <Notifications
            notifications={this.props.notifications}
            style={notificationsStyles}
          />
          {isLoggedIn &&
          loginToken &&
          this.checkTokenExpiration(jwtDecode(loginToken).exp) &&
          location.pathname.split("/")[1] !== "partners" &&
          !viewingDynamicScoreReports &&
          !isInsightUser &&
          this.state.showCriteriaBatteryNotification ? (
            <NewCriteriaBatteryNotification
              dismissNewCriteriaBatteryNotification={
                this.dismissNewCriteriaBatteryNotification
              }
              dispatch={this.props.dispatch}
            />
          ) : null}
          <a
            id="invoice"
            key="invoiceDownload"
            download="invoice.pdf"
            style={{ display: "none" }}
          >
            Invoice
          </a>
          <HelpAssistantModal
            showModal={this.state.showHelpAssistantModal}
            handleCloseHelpAssistantModal={this.handleCloseHelpAssistantModal}
            handleSendResponseFeedback={this.handleSendResponseFeedback}
            handleSendSupportBotQuestion={this.handleSendSupportBotQuestion}
            isAU={userData && userData.isAU}
            responseId={this.props.trackResponseId}
            sendingBotQuestion={this.props.sendingBotQuestion}
            supportBotResponse={this.props.supportBotResponse}
            supportBotResponseError={this.props.supportBotResponseError}
          />
        </Loader>
      </div>
    );
  }
}

App.propTypes = {
  children: node,
  location: object,
  paidThisSession: bool,
  notifications: array,
  roles: object,
  showSessionExpirationModal: bool,
  loginLoading: bool,
  getInvoice: func.isRequired,
  onGetCompanyInfo: func.isRequired,
  onGetRoles: func.isRequired,
  onSaveLastLocation: func.isRequired,
  onGetIdentityProvider: func.isRequired,
  identityProviderMode: number,
  onRefreshUserData: func,
  onSetupFeatureFlags: func,
  featureFlags: object,
  userData: object,
  forceLogout: bool,
  vhs: number,
  onUpdateVhs: func,
  onLogin: func,
  dispatch: func,
  onGetTestBatteries: func,
  hasCreatedTestBatteries: bool,
  onResetSupportBotResponse: func,
  onSendResponseFeedback: func,
  trackResponseId: string,
  sendingBotQuestion: bool,
  supportBotResponse: string,
  supportBotResponseError: bool,
  onSendSupportBotQuestion: func,
  companyInfo: object,
};
const mapStateToProps = (state) => ({
  paidThisSession: state.get("App").get("paidThisSession"),
  partnersErrorCode: state.get("App").get("partnersErrorCode"), // partnersErrorCode variable used to only update page when partner logs in
  notifications: state.get("notifications"),
  roles: state.get("App").get("roles"),
  showSessionExpirationModal: state
    .get("App")
    .get("showSessionExpirationModal"),
  loginLoading: state.get("App").get("loginLoading"),
  identityProviderMode: state.get("App").get("identityProviderMode"),
  featureFlags: state.get("App").get("featureFlags"),
  locations: state.get("route").get("locationBeforeTransitions"),
  userData: state.get("App").get("userData"),
  forceLogout: state.get("App").get("forceLogout"),
  vhs: state.get("App").get("vhs"),
  orderInProcess: state.get("App").get("orderInProcess"),
  hasCreatedTestBatteries: state.get("App").get("hasCreatedTestBatteries"),
  trackResponseId: state.get("App").get("trackResponseId"),
  sendingBotQuestion: state.get("App").get("sendingBotQuestion"),
  supportBotResponse: state.get("App").get("supportBotResponse"),
  supportBotResponseError: state.get("App").get("supportBotResponseError"),
  companyInfo: state.get("App").get("companyInfo"),
});
export function mapDispatchToProps(dispatch) {
  return {
    getInvoice: (invoiceNumber) => dispatch(getInvoice(invoiceNumber)),
    onLogin: (formData) => dispatch(login(formData)),
    onGetCompanyInfo: (redirect) => dispatch(getCompanyInfo(redirect)),
    onGetRoles: () => dispatch(getRoles()),
    onSaveLastLocation: (pathname) => dispatch(saveLastLocation(pathname)),
    onGetUsers: () => dispatch(getUsers()),
    onGetIdentityProvider: (emailAddress, companyAccountId /* rememberMe */) =>
      dispatch(
        getIdentityProvider(emailAddress, companyAccountId /* rememberMe */)
      ),
    onGetDynamicScoreReportsData: (testEventId, source) =>
      dispatch(getDynamicScoreReportsData(testEventId, source)),
    onRefreshUserData: () => dispatch(refreshUserData()),
    onSetupFeatureFlags: (configCatObject) =>
      dispatch(setupFeatureFlag(configCatObject)),
    onUpdateOrderInProcess: () => dispatch(setOrderInProcess()),
    onUpdateVhs: (vhs) => dispatch(updateVhs(vhs)),
    onGetTestBatteries: () => dispatch(getTestBatteries()),
    onResetSupportBotResponse: () => dispatch(resetSupportBotResponse()),
    onSendResponseFeedback: (formData) =>
      dispatch(sendResponseFeedback(formData)),
    onSendSupportBotQuestion: (formData) =>
      dispatch(sendSupportBotQuestion(formData)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
